import { Row } from "antd";
import dayjs from "dayjs";
import React, { useRef } from "react";
import { RiCheckDoubleLine } from "react-icons/ri";
import { useSelector } from "react-redux";
import "../../assets/css/card-parent.css";
import HyperlinkText from "./HyperlinkText";
import Attachment from "./Attachment";
import { forwardRef } from "react";

const Messages = forwardRef(({ conversationData, readByTalent }, ref) => {
 
  const isSameDate = (date1, date2) => {
    return dayjs(date1).isSame(date2, "day");
  };
  
  const chatDateTime = ( date ) => {  
    const inputDate = dayjs(date?.Created);    
    const currentDate = dayjs();
    const isToday = isSameDate(inputDate, currentDate);
    const formattedDate = isToday ? "Today" : inputDate.format("MMM DD");
    return formattedDate ;
  }  
  

  const { userData } = useSelector((state) => state.chat);
  let conversation = [...conversationData];

  return (
    <div
      className="chatcard" ref={ref}
      aria-details={conversation?.length > 1 && "more-than-one-msg"}
    >      
      {conversation?.map((data, key) => {             
        return (
          <>
            <div className="chatDataTime-Admin" key={data?._id+key} >
              {key > 0 ? !isSameDate(data?.Created, conversation[key-1]?.Created) ? chatDateTime(data) : "" : chatDateTime(data)}
            </div>
            <div className="InnerChatCont" key={data?._id}>
              <Row className="spaceTop">
                <div
                  className={
                    data?.SenderUser?.AccountId
                      ? userData?.AccountId === data?.SenderUser?.AccountId
                        ? "left"
                        : "right"
                      : userData?.AccountId === data?.SenderProfileId
                      ? "left"
                      : "right"
                  }
                >
                  <div style={{ width: "22rem" }}>
                    <div
                      className="Plain-text-msg-align"
                      style={{
                        backgroundColor: "#F2F2F2",
                        padding: ".625rem",
                        width: "100%",
                        wordBreak: "break-word",
                        borderRadius: ".3125rem",
                      }}
                    >
                      <div className="subject-font-chat">
                        <HyperlinkText text={data?.Subject} />
                      </div>
                      <HyperlinkText text={data?.MessageText} sub={true} />
                      {data?.Attachments?.length > 0 &&
                        data.Attachments.map((files) => (
                          <Attachment
                            fileName={files.FileName}
                            filePath={files.FilePath}
                            fileSize={files.FileSize}
                          />
                        ))}
                      <div
                        style={{
                          display: "flex",
                          color: "#b4b4b4",
                          fontSize: "14px",
                          justifyContent: "flex-end",
                          fontWeight: "400",
                        }}
                      >
                        <div className="msg-time-stamp">
                          {" "}
                          {dayjs(data?.Created).format("hh:mm A")}{" "}
                        </div>
                        <RiCheckDoubleLine className={(data?.ReadAt || readByTalent.includes(data?.MessageGUID)) ? "double-check-icon" : "double-check-icon-gray"} />
                      </div>
                    </div>
                  </div>
                </div>
              </Row>
            </div>            
          </>
        );
      })}
    </div>
  );
})

export default Messages;